import * as React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import noop from 'lodash/noop';
import ColumnResizeHandler from './ColumnResizeHandler';
import { defaultClassPrefix, getUnhandledProps, isNullOrUndefined, prefix } from './utils';
import Cell from './Cell';
import TableContext from './TableContext';
const propTypes = {
    index: PropTypes.number,
    sortColumn: PropTypes.string,
    dataIndex: PropTypes.string,
    sortType: PropTypes.oneOf(['desc', 'asc']),
    sortable: PropTypes.bool,
    resizable: PropTypes.bool,
    minWidth: PropTypes.number,
    onColumnResizeStart: PropTypes.func,
    onColumnResizeEnd: PropTypes.func,
    onResize: PropTypes.func,
    onColumnResizeMove: PropTypes.func,
    onSortColumn: PropTypes.func,
    flexGrow: PropTypes.number,
    fixed: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['left', 'right'])]),
    children: PropTypes.node,
    onMouseEnterHandler: PropTypes.func,
    onMouseLeaveHandler: PropTypes.func,
};
class HeaderCell extends React.PureComponent {
    constructor(props) {
        super(props);
        this.handleColumnResizeStart = () => {
            const { left = 0, fixed, onColumnResizeStart, resizeLeft = 0 } = this.props;
            onColumnResizeStart?.(this.state.columnWidth, left + resizeLeft, !!fixed);
        };
        this.handleColumnResizeMove = (width, left = 0, fixed) => {
            const { onColumnResizeMove = noop, resizeLeft = 0 } = this.props;
            onColumnResizeMove(width, left + resizeLeft, fixed);
        };
        this.handleColumnResizeEnd = (columnWidth, cursorDelta) => {
            const { dataKey, index, onColumnResizeEnd, onResize } = this.props;
            this.setState({ columnWidth });
            onColumnResizeEnd?.(columnWidth, cursorDelta, dataKey, index);
            onResize?.(columnWidth, dataKey);
        };
        this.handleClick = () => {
            if (this.props.sortable) {
                this.props.onSortColumn?.(this.props.dataKey);
            }
        };
        this.handleShowMouseArea = (left) => {
            const { onMouseEnterHandler = noop, fixed } = this.props;
            onMouseEnterHandler(left, fixed);
        };
        // @ts-ignore
        this.addPrefix = (name) => prefix(this.props.classPrefix)(name);
        this.state = {
            width: props.width,
            flexGrow: props.flexGrow,
            columnWidth: isNullOrUndefined(props.flexGrow) ? props.width : 0,
        };
    }
    static get contextType() {
        return TableContext;
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.width !== prevState.width || nextProps.flexGrow !== prevState.flexGrow) {
            return {
                width: nextProps.width,
                flexGrow: nextProps.flexGrow,
                columnWidth: isNullOrUndefined(nextProps.flexGrow) ? nextProps.width : 0,
            };
        }
        return null;
    }
    renderResizeSpanner() {
        const { resizable, left = 0, onMouseLeaveHandler, fixed, headerHeight, minWidth, groupCount, children, style } = this.props;
        const { columnWidth } = this.state;
        if (!resizable) {
            return null;
        }
        let defaultColumnWidth = columnWidth;
        // 处理组合列第一列拖拽柄定位问题
        if (groupCount && groupCount > 1) {
            defaultColumnWidth = children?.props.children[0].props.width;
        }
        return (React.createElement(ColumnResizeHandler, { defaultColumnWidth: defaultColumnWidth, key: columnWidth, columnLeft: left, columnFixed: fixed, height: headerHeight ? headerHeight - 1 : undefined, minWidth: minWidth, style: { top: style ? style.top : 0 }, onColumnResizeMove: this.handleColumnResizeMove, onColumnResizeStart: this.handleColumnResizeStart, onColumnResizeEnd: this.handleColumnResizeEnd, onMouseEnterHandler: this.handleShowMouseArea, onMouseLeaveHandler: onMouseLeaveHandler }));
    }
    renderSortColumn() {
        const { sortable, sortColumn, sortType = '', dataKey, groupHeader } = this.props;
        if (sortable && !groupHeader) {
            const iconClasses = classNames(this.addPrefix('icon-sort icon'), {
                [this.addPrefix(`icon-sort-${sortType}`)]: sortColumn === dataKey,
            });
            return (React.createElement("span", { className: this.addPrefix('sort-wrapper') },
                React.createElement("i", { className: iconClasses })));
        }
        return null;
    }
    render() {
        const { className, width, dataKey, headerHeight, children, left, sortable, classPrefix, sortColumn, sortType, groupHeader, ...rest } = this.props;
        const classes = classNames(classPrefix, className, {
            [this.addPrefix('sortable')]: sortable,
        });
        const unhandledProps = getUnhandledProps(propTypes, rest);
        let ariaSort;
        if (sortColumn === dataKey) {
            ariaSort = 'other';
            if (sortType === 'asc') {
                ariaSort = 'ascending';
            }
            else if (sortType === 'desc') {
                ariaSort = 'descending';
            }
        }
        return (React.createElement("div", { className: classes },
            React.createElement(Cell, Object.assign({ "aria-sort": ariaSort }, unhandledProps, { width: width, dataKey: dataKey, left: left, headerHeight: headerHeight, isHeaderCell: true, onClick: !groupHeader ? this.handleClick : null }),
                children,
                this.renderSortColumn()),
            this.renderResizeSpanner()));
    }
}
HeaderCell.propTypes = propTypes;
HeaderCell.defaultProps = {
    classPrefix: defaultClassPrefix('performance-table-cell-header'),
};
export default HeaderCell;
